import { useSpmTerminalKind } from '@/reporting/spm/spm-dom';
import { resolveSpmTerminalKind, type SpmTerminalKind } from '@/reporting/spm/terminal';
import { getSpmSitePrefix } from '@/reporting/spm/site';

/**
 * 首页楼层 SPM C 位模块编码：不再使用静态编码表语义名，统一按楼块数据动态拼接
 * `${component_id}_${id}`（component_id 与 id 为每个楼层块数据已有字段）。
 * A 位站点段由站点配置推导（见 src/reporting/spm/site.ts），不写死站点。
 * App 内嵌时 WAP 版楼层 B 位上报 home_app 而非 home_wap（C/D 不变）。
 * 坑位（D 位）编码由调用方追加：`${spmModule}.${position}`，position 沿用既有坑位命名。
 *
 * 渲染期请用 useHomeSpmModuleCode（终端段来自 Provider 下发的服务端判定，SSR
 * 与客户端同值）；本纯函数供事件回调与非 hook 场景使用（UA 兜底）。
 */
export function buildSpmModuleCode(
  componentId: string | number | null | undefined,
  id: string | number | null | undefined,
  page: 'home_pc' | 'home_wap',
  terminalKind?: SpmTerminalKind,
): string {
  const kind = terminalKind ?? resolveSpmTerminalKind();
  const pageId = page === 'home_wap' && kind === 'app' ? 'home_app' : page;
  const c = [componentId, id].filter(
    (part) => part !== undefined && part !== null && `${part}` !== '',
  );
  return c.length ? `${getSpmSitePrefix()}.${pageId}.${c.join('_')}` : '';
}

/** 渲染期取首页楼层模块编码：App 内嵌判定走 Provider 下发的服务端终端段。 */
export function useHomeSpmModuleCode(
  componentId: string | number | null | undefined,
  id: string | number | null | undefined,
  page: 'home_pc' | 'home_wap',
): string {
  const terminalKind = useSpmTerminalKind();
  return buildSpmModuleCode(componentId, id, page, terminalKind);
}
